export default __webpack_public_path__ + "static/media/thum6.c8e58bdd.jpg";